<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="app-page-title">
                    <div class="page-title-wrapper mt-4">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-notebook icon-gradient bg-mixed-hopes"></i>
                            </div>
                            <div>
                                Create Service Call / Complaints <div class="page-title-subheading"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="main-card mb-3 card">
                        
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6" style=" margin-left: 10px;">
                                    <p> Fields marked with <span style="color: red;">*</span> are required.</p>
                                </div>
                            </div>
                            
                            <form [formGroup]="proposalFrm">
                                <div class="row" style="width: 95%; margin-left: 10px; margin-top: 10px;">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="subject">Subject <span style="color: red;">*</span></label>
                                            <input id="subject" placeholder="Enter Subject" type="text" required
                                                formControlName="subject" class="form-control">
                                            <div class="text-danger"
                                                *ngIf="submitted && proposalFrm.get('subject').errors">
                                                <div *ngIf="proposalFrm.get('subject').hasError('required')">Subject
                                                    cannot be blank.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="position-relative form-group">
                                            <label for="soNumber">SO Number (Project Name) <span
                                                    style="color: red;">*</span></label>
                                            <select (change)="selectProjectHead($event)" name="soNumber" id="soNumber"
                                                class="form-control" formControlName="soNumber" required>
                                                <option value="" disabled selected>Select SO Number (Project Name)
                                                </option>
                                                <option *ngFor="let soList of soList" [value]="soList.id">
                                                    {{ soList.name }}
                                                </option>
                                            </select>
                                            <div class="text-danger"
                                                *ngIf="submitted && proposalFrm.get('soNumber').errors">
                                                <div *ngIf="proposalFrm.get('soNumber').hasError('required')">SO Number
                                                    (Project Name) cannot be blank.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="email">E-Mail <span style="color: red;">*</span></label>
                                            <div class="input-group">
                                                <input id="email" placeholder="Enter E-Mail" type="email"
                                                    formControlName="email" class="form-control">
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="submitted && proposalFrm.get('email').errors">
                                                <div *ngIf="proposalFrm.get('email').hasError('required')">E-Mail cannot
                                                    be blank.</div>
                                                <div *ngIf="proposalFrm.get('email').hasError('pattern')">E-Mail is not a
                                                    valid e-mail address.</div>
                                                  <div *ngIf="proposalFrm.get('email').touched && proposalFrm.get('email').errors?.serverError">
                                                    <!-- Rajesh : WIll remove in next commit -->
                                                    <!-- <small class="text-danger">
                                                      {{ proposalFrm.get('email').errors?.serverError }}
                                                    </small> -->
                                                    <div class="text-danger">{{ proposalFrm.get('email').errors?.serverError }}</div>
                                                  </div>                                             
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="imageUpload">Attachements</label>
                                            <div class="input-group">
                                                <input id="imageUpload" type="file" accept="image/*,application/pdf" multiple
                                                    class="form-control" style="padding: 0.2rem;"
                                                    title="Select image files or PDF files to upload"
                                                    placeholder="No files selected"
                                                    (change)="onImageSelect($event)">
                                            </div>
                                            <small *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</small>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="position-relative form-group">
                                            <label for="complaintDetails">Complaint Description <span
                                                    style="color: red;">*</span></label>

                                            <angular-editor formControlName="complaintDetails" [config]="editorConfigNew"></angular-editor>

                                            <div class="text-danger"
                                                *ngIf="submitted && proposalFrm.get('complaintDetails').errors">
                                                <div *ngIf="proposalFrm.get('complaintDetails').hasError('required')">
                                                    Complaint Description cannot be blank.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <button class="mt-2 btn btn-primary" name="submit" type="submit"
                                                (click)="onSubmit()"
                                                [disabled]="proposalFrm.invalid && submitted">Submit</button>
                                            <button class="mt-2 btn btn-danger" name="submit" type="submit"
                                                style="margin-left: 10px;" (click)="goBack()">Cancel</button>

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>